import { component } from 'picoapp'
import $ from 'quantdom'

export default component((node) => {
  const _updateImages = (facts) => {
    let html = ''
    if (facts) {
      const hasMultipleFacts = facts.length > 1
      if (hasMultipleFacts) {
        html += `<div class="tw-h-full tw-flex tw-flex-col tw-gap-y-3">`
      }
      facts.forEach((fact) => {
        const altLabel = fact.alt ? `alt="${fact.alt}"` : ''
        html += `
        <img
          src="${fact.image}"
          ${altLabel}
          aria-label="${fact.aria_label}"
          class="${facts.length === 1 ? 'tw-pt-10 tw-pb-10 ' : 'first:tw-pt-10 last:tw-pb-10 '}tw-object-contain" />
      `
      })
      if (hasMultipleFacts) {
        html += `</div>`
      }
      $(node).find('[data-supplement-facts]').html(html)
    }
  }

  let variantId = new URL(window.location).searchParams.get('variant')
  if (!variantId) {
    if (window.product?.selected_or_first_available_variant) {
      variantId = window.product.selected_or_first_available_variant.id
    } else if (window.product?.variants.length > 0) {
      variantId = window.product.variants[0].id
    }
  }
  if (variantId) {
    _updateImages(window.supplement_facts[variantId])
  }

  window.MicroBus.on('variant:change', (e) => {
    $(node).find('[data-supplement-facts]').html('')
    window.allVariants.find((variant) => {
      if (variant.id == e.detail) {
        _updateImages(window.supplement_facts[variant.id])
        return
      }
    })
  })

  window.MicroBus.on('product:html-replaced', (e) => {
    let selectedVariantId = e.detail.one_time_id ?? null
    _updateImages(window.supplement_facts[selectedVariantId])
  })
})

document.addEventListener('DOMContentLoaded', function () {
  const modalItem = document.getElementById('supplement-facts')

  function checkImageSize() {
    var supplementFactsDiv = modalItem.querySelector('div[data-supplement-facts]')

    if (supplementFactsDiv) {
      var images = Array.from(supplementFactsDiv.querySelectorAll('img'))

      if (images.length > 0) {
        function onImagesLoad() {
          var totalHeight = images.reduce(function (acc, img) {
            return acc + img.clientHeight
          }, 0)

          var viewportHeight = window.innerHeight || document.documentElement.clientHeight

          if (totalHeight > viewportHeight) {
            supplementFactsDiv.classList.add('tw-h-full')
          } else {
            supplementFactsDiv.classList.remove('tw-h-full')
          }
        }

        var imagesLoaded = images.every(function (img) {
          return img.complete
        })

        if (imagesLoaded) {
          onImagesLoad()
        } else {
          images.forEach(function (img) {
            img.onload = onImagesLoad
          })
        }

        window.addEventListener('resize', onImagesLoad)

        modalItem.addEventListener('close', function () {
          window.removeEventListener('resize', onImagesLoad)
        })
      }
    }
  }

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
        if (modalItem.hasAttribute('open')) {
          checkImageSize()
        }
      }
    })
  })

  observer.observe(modalItem, { attributes: true })

  if (modalItem.hasAttribute('open')) {
    checkImageSize()
  }
})
